export default __webpack_public_path__ + "static/media/logo.e8d87f86.png";